<mat-form-field>
  <mat-label>Manufacturer</mat-label>
  <mat-chip-grid #chipList aria-label="Manufacturer selection">
    @for (manufacturer of selectedManufacturers; track manufacturer) {
    <mat-chip-row [removable]="removable" (removed)="remove(manufacturer)">
      {{ manufacturer.name }}
      @if (removable) {
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
    }
    <input
      placeholder="Manufacturer"
      #manufacturerInput
      [formControl]="manufacturerCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (manufacturer of filteredManufacturers | async; track manufacturer) {
    <mat-option [value]="manufacturer">
      {{ manufacturer.name }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
